import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-421d4bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-history-dialog" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "history-modal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "history-modal-title" }, "聊天记录", -1))
const _hoisted_5 = { class: "history-modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "history-loading"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载聊天记录中...", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "history-empty"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无聊天记录", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "history-header" }
const _hoisted_13 = { class: "history-header-left" }
const _hoisted_14 = { class: "history-customer" }
const _hoisted_15 = { class: "history-source" }
const _hoisted_16 = { class: "history-header-right" }
const _hoisted_17 = { class: "history-date" }
const _hoisted_18 = { class: "history-count" }
const _hoisted_19 = {
  key: 0,
  class: "history-msg-time"
}
const _hoisted_20 = { class: "history-msg-content" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))

import { ref, watch, nextTick, PropType } from 'vue';
import { renderMarkdown } from '@/utils/markdown';

interface ChatMessage {
  id?: number;
  senderType: string;
  messageContent: string;
  messageType: string;
  sendTime?: string;
}

interface SessionInfo {
  customerName?: string;
  sourceLabel?: string;
  statusLabel?: string;
  statusClass?: string;
  dateLabel?: string;
  messageCount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatHistoryDialog',
  props: {
  messages: { type: Array as PropType<ChatMessage[]>, default: () => [] },
  loading: { type: Boolean, default: false },
  sessionInfo: { type: Object as PropType<SessionInfo>, default: () => ({}) },
  openDialog: { type: Function as PropType<() => void>, required: true }
},
  setup(__props) {

const props = __props



const dialogVisible = ref(false);
const opening = ref(false);
const msgContainer = ref<HTMLElement>();

const scrollToBottom = () => {
  if (msgContainer.value) {
    msgContainer.value.scrollTop = msgContainer.value.scrollHeight;
  }
};

watch(
  () => props.messages,
  () => {
    nextTick(() => scrollToBottom());
  },
  { immediate: true }
);

watch(
  () => props.loading,
  (val) => {
    if (!val) {
      opening.value = false;
    }
  }
);

const onOpenDialog = () => {
  opening.value = true;
  dialogVisible.value = true;
  props.openDialog();
};

const onCloseDialog = () => {
  dialogVisible.value = false;
};

const shouldShowTime = (index: number): boolean => {
  const msgs = props.messages;
  if (index === 0) return true;
  const prev = msgs[index - 1];
  const curr = msgs[index];
  if (!prev.sendTime || !curr.sendTime) return false;
  return new Date(curr.sendTime).getTime() - new Date(prev.sendTime).getTime() > 5 * 60 * 1000;
};

const formatTime = (time?: string): string => {
  if (!time) return '';
  const d = new Date(time);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "history-action-area" }, [
      _createElementVNode("button", {
        class: "history-view-btn",
        onClick: onOpenDialog
      }, "查看详情")
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (dialogVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "history-overlay",
            onClick: _withModifiers(onCloseDialog, ["self"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", { class: "history-modal-header" }, [
                _hoisted_4,
                _createElementVNode("button", {
                  class: "history-modal-close",
                  onClick: onCloseDialog
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (__props.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : (!__props.messages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(__props.sessionInfo.customerName || '未知用户'), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(__props.sessionInfo.sourceLabel), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["history-status", __props.sessionInfo.statusClass])
                            }, _toDisplayString(__props.sessionInfo.statusLabel), 3)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(__props.sessionInfo.dateLabel), 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(__props.sessionInfo.messageCount) + " 条消息", 1)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "history-messages",
                          ref_key: "msgContainer",
                          ref: msgContainer
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.messages, (msg, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: msg.id || index,
                              class: _normalizeClass(["history-msg-row", msg.senderType === 'CUSTOMER' ? 'msg-row-right' : 'msg-row-left'])
                            }, [
                              (shouldShowTime(index))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(formatTime(msg.sendTime)), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["history-avatar", msg.senderType === 'CUSTOMER' ? 'avatar-customer' : 'avatar-ai'])
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(msg.senderType === 'CUSTOMER' ? '客' : 'AI'), 1)
                                ], 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["history-bubble", {
                        'bubble-customer': msg.senderType === 'CUSTOMER',
                        'bubble-ai': msg.senderType === 'AI',
                        'bubble-system': msg.senderType === 'SYSTEM'
                      }])
                                }, [
                                  _createElementVNode("div", {
                                    class: "history-bubble-text",
                                    innerHTML: _unref(renderMarkdown)(msg.messageContent)
                                  }, null, 8, _hoisted_21)
                                ], 2)
                              ])
                            ], 2))
                          }), 128)),
                          _hoisted_22
                        ], 512)
                      ], 64))
              ])
            ])
          ], 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})